/**
 * @package DMV Navigation
 * @version 1.0.0
 */

$('#accordion ul.collapse')
  .on('show.bs.collapse', function() {
    $(this)
      .prev('a')
      .find('i')
      .addClass('fa-chevron-up')
      .removeClass('fa-chevron-down');
  })
  .on('hide.bs.collapse', function() {
    $(this)
      .prev('a')
      .find('i')
      .addClass('fa-chevron-down')
      .removeClass('fa-chevron-up');
  });



// WEBPACK FOOTER //
// ./scripts/plugins/dmv-navigation/index.js